import { IntlShape } from 'react-intl';
import { messages } from './messages';

const Schema = (intl: IntlShape) => ({
  title: intl.formatMessage(messages.Distributor),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['title', 'items'],
    },
  ],
  properties: {
    title: {
      title: intl.formatMessage(messages.Title),
      widgetOptions: {
        frontendOptions: {
          widget: 'text',
        },
      },
    },
    items: {
      title: intl.formatMessage(messages.Items),
      description: intl.formatMessage(messages.ItemsHelp),
      widgetOptions: {
        frontendOptions: {
          widget: 'object_browser',
        },
      },
      default: [],
    },
  },
  required: [],
});

export default Schema;
